<template>
    <div class="slide-canvas">
        <BackgroundImage :image-src="image" />
        <Confetti ref="confetti" />
        <div
            ref="overlay"
            :class="[`${color}-background`]"
            class="overlay"
        />
    </div>
</template>

<script>
import gsap from 'gsap';
import ImageLoader from '@kids/lib/class/ImageLoader';
import BackgroundImage from './BackgroundImage.vue';
import Confetti from './Confetti.vue';

export default {
    name: 'SlideCanvas',
    components: {
        BackgroundImage,
        Confetti
    },
    data: () => ({
        color: 'blue',
        image: ''
    }),
    mounted()
    {
        this.animateInset({});
    },
    methods:
    {
        animateInset(config, duration = 0, fromFull = false, fromNull = false)
        {
            if (this._insetTimeline)
            {
                this._insetTimeline.kill();
                this._insetTimeline = null;
            }
            const fullConfig = {top: 0, right: 0, bottom: 0, left: 0, duration};
            const nullConfig = {top: 0, right: '100%', bottom: 0, left: 0, duration};
            const vars = {...fullConfig, ...config};
            const timeline = gsap.timeline();

            if (fromFull)
            {
                timeline.to(this.$refs.overlay, fullConfig);
            }
            else if (fromNull)
            {
                timeline.to(this.$refs.overlay, nullConfig);
            }
            timeline.to(this.$refs.overlay, vars);
            this._insetTimeline = timeline;
        },
        animateTransition(config)
        {
            const {
                duration,
                color,
                image,
                timeScale,
                triggerHandler,
                changeImageInstantly
            } = config;

            this.animateInset(
                config.inset,
                duration,
                config.insetFromFull,
                config.insetFromNull
            );

            const timeline = this._insetTimeline;

            if (config.swoosh)
            {
                timeline.add(
                    () => this.$audioController.play('swoosh', {volume: 0.3}),
                    `-=${duration}`
                );
            }

            if (typeof image === 'string')
            {
                timeline.set(this, {image}, changeImageInstantly ? 0 : (duration * 0.3));
            }

            if (color)
            {
                timeline.set(this, {color}, duration * 0.5);
            }

            const contentTriggerStagger = `+=${timeScale ? (timeScale * 0.2) : 0.2}`;

            if (triggerHandler)
            {
                timeline.add(() => triggerHandler(0), `-=${duration * 0.75}`);
                timeline.add(() => triggerHandler(1), `-=${duration * 0.5}`);
                timeline.add(() => triggerHandler(2));
            }

            if (config.confetti)
            {
                timeline.add(() => this.$refs.confetti.animate());
            }

            if (triggerHandler)
            {
                timeline.add(() => triggerHandler(3), contentTriggerStagger);
                timeline.add(() => triggerHandler(4), contentTriggerStagger);
                timeline.add(() => triggerHandler(5), contentTriggerStagger);
                timeline.add(() => triggerHandler(6), contentTriggerStagger);
            }
        },
        setBackgroundImages(images)
        {
            const loader = new ImageLoader(images);
            this.$children[0].setLoader(loader);
            return loader.loaded;
        }
    }
};
</script>

<style lang="scss" src="./SlideCanvas.scss" />

